module.exports = __webpack_public_path__ + "img/500-desktop.b697162.svg";